import { Link } from "react-router-dom";
import { ArrowRight, Sprout, TreePine, Scissors, Wrench, Droplets, Shovel, ArrowUpFromLine, CloudRain } from "lucide-react";
import { services } from "../mock";

const iconMap = { Sprout, TreePine, Scissors, Wrench, Droplets, Shovel, ArrowUpFromLine, CloudRain };

export default function Servizi() {
  return (
    <div>
      {/* HERO */}
      <section className="relative pt-40 pb-24 bg-sage-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl reveal">
            <span className="text-xs tracking-[0.3em] uppercase text-sage-600">Servizi</span>
            <h1 className="font-serif text-5xl md:text-7xl text-sage-900 mt-4 leading-[1.05] mb-6">
              Problemi?<br />
              <span className="italic text-sage-700">Una soluzione per tutto.</span>
            </h1>
            <p className="text-lg text-sage-800/70 leading-relaxed">
              Dal servizio più semplice fino agli interventi più complessi.
            </p>
          </div>
        </div>
      </section>

      {/* SERVICES ALTERNATING LIST */}
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-24 md:space-y-32">
          {services.map((s, idx) => {
            const Icon = iconMap[s.icon];
            const reversed = idx % 2 === 1;
            return (
              <div
                key={s.id}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-14 items-center reveal ${
                  reversed ? "lg:[direction:rtl]" : ""
                }`}
              >
                <div className="relative lg:[direction:ltr] group">
                  <div className={`absolute -inset-4 border-2 border-sage-300 rounded transition-transform duration-500 ${reversed ? "group-hover:-translate-x-2" : "group-hover:translate-x-2"} group-hover:-translate-y-2`} />
                  {s.rotate ? (
                    <div className="relative w-full h-[480px] overflow-hidden rounded shadow-xl bg-sage-100 flex items-center justify-center">
                      <img
                        src={s.image}
                        alt={s.title}
                        className="max-w-none"
                        style={{ height: "440px", width: "auto", transform: "rotate(90deg)" }}
                      />
                    </div>
                  ) : (
                    <img
                      src={s.image}
                      alt={s.title}
                      className="relative w-full h-[480px] object-cover rounded shadow-xl"
                    />
                  )}
                </div>
                <div className="lg:[direction:ltr]">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-14 h-14 rounded-full bg-sage-100 flex items-center justify-center">
                      {Icon && <Icon className="w-6 h-6 text-sage-700" strokeWidth={1.5} />}
                    </div>
                    <span className="text-xs tracking-[0.3em] uppercase text-sage-600">
                      0{idx + 1} — Servizio
                    </span>
                  </div>
                  <h2 className="font-serif text-4xl md:text-5xl text-sage-900 mb-6 leading-tight">
                    {s.title}
                  </h2>
                  <p className="text-lg text-sage-800/80 leading-relaxed mb-8">
                    {s.longDescription}
                  </p>

                  <Link
                    to={`/servizi/${s.id}`}
                    className="inline-flex items-center gap-3 px-7 py-3.5 bg-sage-700 text-white rounded-full text-sm tracking-wide hover:bg-sage-800 transition-all group"
                  >
                    Dettagli servizio
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-cream">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center reveal">
          <h2 className="font-serif text-4xl md:text-5xl text-sage-900 mb-6">Non trovi quello che cerchi?</h2>
          <p className="text-lg text-sage-700/80 mb-10">
            Contattaci per una consulenza personalizzata. Ogni giardino è unico e così dovrebbe essere anche il servizio.
          </p>
          <Link to="/contatti" className="inline-flex items-center gap-3 px-8 py-4 bg-sage-700 text-white rounded-full text-sm tracking-wide hover:bg-sage-800 transition-all">
            Richiedi preventivo <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
